(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rba-crewneck-swatch-fix-v2"] && !Shopify.designMode) return;
  try {
    (() => {
  const rbaCrewneckV2PriceCache = new Map();
  const rbaCrewneckV2PriceRequests = new Map();

  const rbaCrewneckV2PriceNode = (tierInput) => {
    const copy = tierInput?.closest('.rba-tier-card')?.querySelector('.rba-tier-card__copy');
    if (!copy) return null;
    let price = copy.querySelector('[data-rba-tier-price]') || copy.querySelector('b');
    if (!price) {
      price = document.createElement('b');
      price.setAttribute('data-rba-tier-price', '');
      copy.append(price);
    }
    return price;
  };

  const rbaCrewneckV2WhiteInput = (picker) => {
    const swatches = Array.from(picker?.querySelectorAll('.rba-colour-swatch') || []);
    const whiteSwatch = swatches.find(
      (swatch) => (swatch.getAttribute('title') || '').trim().toLowerCase() === 'white'
    );
    return whiteSwatch?.querySelector('input[data-option-value-id]') || null;
  };

  const rbaCrewneckV2Key = (picker, tierInput, colourInput, sizeInput) => [
    picker?.dataset.productId || '',
    tierInput?.dataset.optionValueId || '',
    colourInput?.dataset.optionValueId || '',
    sizeInput?.dataset.optionValueId || '',
  ].join(':');

  const rbaCrewneckV2ApplySelectedPrice = (picker, tierInput, priceText) => {
    if (!tierInput?.checked || !priceText) return;
    const section = picker.closest('.shopify-section');
    const topPrice = section?.querySelector('[ref="priceContainer"] .price .money');
    if (topPrice) topPrice.textContent = priceText;
    const summaryPrice = section?.querySelector('[data-rba-selection-price]');
    if (summaryPrice) summaryPrice.textContent = priceText;
  };

  const rbaCrewneckV2FetchPrice = (picker, tierInput, colourInput, sizeInput) => {
    const key = rbaCrewneckV2Key(picker, tierInput, colourInput, sizeInput);
    if (rbaCrewneckV2PriceCache.has(key)) return Promise.resolve(rbaCrewneckV2PriceCache.get(key));
    if (rbaCrewneckV2PriceRequests.has(key)) return rbaCrewneckV2PriceRequests.get(key);

    const request = (async () => {
      try {
        const tierId = tierInput?.dataset.optionValueId || '';
        const colourId = colourInput?.dataset.optionValueId || '';
        const sizeId = sizeInput?.dataset.optionValueId || '';
        const sectionId = picker?.dataset.sectionId || '';
        if (!tierId || !colourId || !sizeId || !sectionId) return '';

        const productUrl = new URL(picker.dataset.productUrl || window.location.pathname, window.location.origin);
        const currentUrl = new URL(window.location.href);
        const url = new URL(productUrl.pathname, window.location.origin);
        currentUrl.searchParams.forEach((value, param) => {
          if (param.startsWith('preview_') || param === 'pb') url.searchParams.set(param, value);
        });
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('option_values', `${tierId},${colourId},${sizeId}`);

        const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) return '';
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedTier = doc.querySelector(
          `.rba-option--tiers input[data-option-value-id="${CSS.escape(tierId)}"]`
        );
        const priceText = fetchedTier
          ?.closest('.rba-tier-card')
          ?.querySelector('.rba-tier-card__copy b')
          ?.textContent
          ?.trim() || '';
        if (priceText) rbaCrewneckV2PriceCache.set(key, priceText);
        return priceText;
      } catch (_error) {
        return '';
      } finally {
        rbaCrewneckV2PriceRequests.delete(key);
      }
    })();

    rbaCrewneckV2PriceRequests.set(key, request);
    return request;
  };

  const rbaCrewneckV2Hydrate = async (marker) => {
    const section = marker?.closest('.shopify-section');
    const picker = section?.querySelector('.rba-tee-picker');
    if (!picker) return;
    const sizeInput = picker.querySelector('.rba-option--sizes input:checked[data-option-value-id]');
    const whiteInput = rbaCrewneckV2WhiteInput(picker);
    const tierInputs = Array.from(picker.querySelectorAll('.rba-option--tiers input[data-option-value-id]'));
    if (!sizeInput || !whiteInput || !tierInputs.length) return;

    await Promise.all(tierInputs.map(async (tierInput) => {
      const priceText = await rbaCrewneckV2FetchPrice(picker, tierInput, whiteInput, sizeInput);
      if (!priceText) return;
      const priceNode = rbaCrewneckV2PriceNode(tierInput);
      if (priceNode) priceNode.textContent = priceText;
      rbaCrewneckV2ApplySelectedPrice(picker, tierInput, priceText);
    }));
  };

  const rbaCrewneckV2Initialize = (root = document) => {
    root.querySelectorAll?.('[data-rba-crewneck-price-fix-v2]').forEach((marker) => {
      rbaCrewneckV2Hydrate(marker);
    });
  };

  document.addEventListener('change', (event) => {
    const picker = event.target?.closest?.('.rba-tee-picker');
    if (!picker) return;
    const marker = picker.closest('.shopify-section')?.querySelector('[data-rba-crewneck-price-fix-v2]');
    if (!marker) return;
    if (event.target.closest('.rba-option--tiers') || event.target.closest('.rba-option--sizes')) {
      requestAnimationFrame(() => rbaCrewneckV2Hydrate(marker));
    }
  }, true);

  document.addEventListener('shopify:product:select', (event) => {
    const section = event.target?.closest?.('.shopify-section');
    const marker = section?.querySelector?.('[data-rba-crewneck-price-fix-v2]');
    if (!marker) return;
    Promise.resolve(event.promise)
      .then(() => {
        requestAnimationFrame(() => rbaCrewneckV2Hydrate(marker));
        window.setTimeout(() => rbaCrewneckV2Hydrate(marker), 120);
      })
      .catch(() => {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => rbaCrewneckV2Initialize(), { once: true });
  } else {
    requestAnimationFrame(() => rbaCrewneckV2Initialize());
  }
  document.addEventListener('shopify:section:load', (event) => rbaCrewneckV2Initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rba-crewneck-tier-images"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__rbaCrewneckTierImagesReady) return;
  window.__rbaCrewneckTierImagesReady = true;

  const normalize = (value) => (value || '').trim().toLowerCase();

  const tierKeyFromText = (value) => {
    const text = normalize(value);
    if (text.includes('essential')) return 'essential';
    if (text.includes('premium')) return 'premium';
    if (text.includes('elevated')) return 'elevated';
    return '';
  };

  const selectedColour = (picker) => {
    const input = picker.querySelector('.rba-option--colours input:checked');
    return input?.closest('.rba-colour-swatch')?.getAttribute('title')?.trim() || '';
  };

  const chooseMedia = (entries, tierKey, colour) => {
    const tierEntries = entries.filter((entry) => normalize(entry.dataset.tier) === tierKey);
    if (!tierEntries.length) return null;

    const colourKey = normalize(colour);
    let chosen = colourKey
      ? tierEntries.find((entry) => normalize(entry.dataset.colour) === colourKey)
      : null;

    if (chosen) return chosen;

    const fallbacks = tierKey === 'elevated'
      ? ['pepper', 'true navy', 'white']
      : ['black', 'navy', 'charcoal', 'white'];

    for (const fallback of fallbacks) {
      chosen = tierEntries.find((entry) => normalize(entry.dataset.colour) === fallback);
      if (chosen) return chosen;
    }

    return tierEntries[0];
  };

  const syncConfig = (config) => {
    const scope = config.closest('.product-information') || config.closest('.shopify-section') || document;
    const picker = scope.querySelector('.rba-tee-picker');
    if (!picker) return;

    const colour = selectedColour(picker);
    const entries = Array.from(config.querySelectorAll('[data-rba-crewneck-media]'));

    picker.querySelectorAll('.rba-tier-shell').forEach((shell) => {
      const tierKey = tierKeyFromText(shell.querySelector('.rba-tier-card__copy strong')?.textContent);
      if (!tierKey) return;

      const src = config.dataset[`${tierKey}Src`];
      const alt = config.dataset[`${tierKey}Alt`] || '';
      const image = shell.querySelector('.rba-tier-card__media img');

      if (image && src) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        if (image.getAttribute('src') !== src) image.setAttribute('src', src);
        image.setAttribute('alt', alt);
      }

      const media = chooseMedia(entries, tierKey, colour);
      if (media?.dataset.mediaId) {
        shell.dataset.rbaTierMediaId = media.dataset.mediaId;
      }
    });
  };

  const syncAll = () => {
    document.querySelectorAll('.rba-crewneck-tier-image-config').forEach(syncConfig);
  };

  const scheduleSync = () => {
    requestAnimationFrame(syncAll);
    window.setTimeout(syncAll, 120);
    window.setTimeout(syncAll, 450);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  document.addEventListener('change', (event) => {
    if (!event.target?.closest?.('.rba-tee-picker')) return;
    scheduleSync();
  }, true);

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:block:select', scheduleSync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rba-crewneck-variant-picker-v2"] && !Shopify.designMode) return;
  try {
    const showRbaFeaturedMedia = () => {
    document.querySelectorAll('.rba-tee-picker[data-rba-featured-media-id]').forEach((picker) => {
      if (picker.dataset.rbaInitialMediaReady === 'true') return;

      // Prefer the currently-checked tier's own mockup photo on first load, same as the
      // t-shirt picker. Falls back to the product's default featured media only if this
      // tier has no mockup photo tagged for it at all.
      const checkedShell = picker.querySelector('.rba-tier-list input:checked')?.closest('.rba-tier-shell');
      const mediaId = checkedShell?.dataset.rbaTierMediaId || picker.dataset.rbaFeaturedMediaId;

      const section = picker.closest('.shopify-section');
      const gallery = section?.querySelector('media-gallery');
      const slideshow = gallery?.slideshow;
      const slides = slideshow?.slides;

      if (!mediaId || !slideshow || !slides?.length) return;

      const targetIndex = slides.findIndex((slide) => slide.querySelector(`.product-media[data-media-id="${mediaId}"]`));
      if (targetIndex < 0) return;

      slideshow.select(targetIndex, undefined, { animate: false });
      picker.dataset.rbaPendingMediaId = mediaId;
      picker.dataset.rbaInitialMediaReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showRbaFeaturedMedia, { once: true });
  } else {
    requestAnimationFrame(showRbaFeaturedMedia);
  }


  const applyRbaDefaultTier = () => {
    document.querySelectorAll('.rba-tee-picker[data-rba-default-tier]').forEach((picker) => {
      if (picker.dataset.rbaDefaultTierApplied === 'true') return;
      picker.dataset.rbaDefaultTierApplied = 'true';

      const defaultTier = picker.dataset.rbaDefaultTier;
      if (!defaultTier) return;

      try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('variant')) return;
      } catch (error) {}

      const shells = Array.from(picker.querySelectorAll('.rba-tier-list .rba-tier-shell'));
      const targetShell = shells.find((shell) => {
        const name = shell.querySelector('.rba-tier-card__copy strong')?.textContent?.trim().toLowerCase() || '';
        return name === defaultTier;
      });
      if (!targetShell) return;

      const input = targetShell.querySelector('input');
      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaDefaultTier, { once: true });
  } else {
    requestAnimationFrame(applyRbaDefaultTier);
  }

  const selectGalleryMedia = (picker, mediaId) => {
    if (!mediaId) return false;
    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    const slideshow = gallery?.slideshow;
    const slides = slideshow?.slides;
    if (!slideshow || !slides?.length) return false;

    const targetIndex = slides.findIndex((slide) => slide.querySelector(`.product-media[data-media-id="${mediaId}"]`));
    if (targetIndex < 0) return false;

    const currentIndex = typeof slideshow.selected === 'number' ? slideshow.selected : slideshow.current;
    if (currentIndex !== targetIndex) {
      slideshow.select(targetIndex, undefined, { animate: false });
    }
    return true;
  };

  const clearRbaTierWatcher = (picker) => {
    const watcher = picker._rbaTierWatcher;
    if (!watcher) return;
    window.clearInterval(watcher.interval);
    watcher.observer?.disconnect();
    picker._rbaTierWatcher = null;
  };

  // Watches the gallery via MutationObserver instead of guessing with fixed timeouts.
  // This is what actually stops the flash: a same-tick DOM override (from Shopify's own
  // native variant-select behaviour, which we don't control and which can run faster
  // than a requestAnimationFrame/setTimeout retry) gets corrected the instant it
  // happens, not on a schedule that might be a frame too slow.
  const watchRbaTierMedia = (picker, mediaId, duration = 4000) => {
    clearRbaTierWatcher(picker);
    if (!mediaId) return;

    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    if (!gallery) return;

    const stopAt = performance.now() + duration;

    const reassert = () => {
      if (picker.dataset.rbaLastInteraction !== 'tier') { clearRbaTierWatcher(picker); return; }
      if (performance.now() >= stopAt) { clearRbaTierWatcher(picker); return; }
      selectGalleryMedia(picker, mediaId);
    };

    const observer = new MutationObserver(reassert);
    observer.observe(gallery, { childList: true, subtree: true, attributes: true });
    const interval = window.setInterval(reassert, 50);

    picker._rbaTierWatcher = { interval, observer };
    reassert();
  };

  const clearRbaColourMediaLock = (picker) => {
    const lock = picker._rbaColourMediaLock;
    if (!lock) return;
    window.cancelAnimationFrame(lock.raf);
    picker._rbaColourMediaLock = null;
  };

  const lockRbaColourMedia = (picker, mediaId, duration = 2200) => {
    clearRbaColourMediaLock(picker);
    if (!mediaId) return;

    const stopAt = performance.now() + duration;
    const lock = { mediaId, raf: 0 };
    picker._rbaColourMediaLock = lock;

    const tick = () => {
      if (picker._rbaColourMediaLock !== lock) return;
      if (picker.dataset.rbaLastInteraction !== 'colour' || performance.now() >= stopAt) {
        clearRbaColourMediaLock(picker);
        return;
      }

      selectGalleryMedia(picker, mediaId);
      lock.raf = window.requestAnimationFrame(tick);
    };

    lock.raf = window.requestAnimationFrame(tick);
  };

  const updateRbaTopPrice = (picker, shell) => {
    const priceText = shell.querySelector('.rba-tier-card__copy b')?.textContent?.trim();
    if (!priceText) return;
    const section = picker.closest('.shopify-section');
    const moneyEl = section?.querySelector('[ref="priceContainer"] .price .money');
    if (moneyEl) moneyEl.textContent = priceText;

    const summaryPriceEl = section?.querySelector('[data-rba-selection-price]');
    if (summaryPriceEl) summaryPriceEl.textContent = priceText;
  };

  const rbaTierColourMapCache = new WeakMap();

  const getRbaTierColourMap = (picker) => {
    if (rbaTierColourMapCache.has(picker)) return rbaTierColourMapCache.get(picker);
    const raw = picker.dataset.rbaTierColourPairs || '';
    const map = new Map();
    raw.split(';;').forEach((pair) => {
      if (!pair) return;
      const [tier, colour] = pair.split('||');
      if (!tier || !colour) return;
      const key = tier.toLowerCase();
      if (!map.has(key)) map.set(key, []);
      const list = map.get(key);
      if (!list.includes(colour)) list.push(colour);
    });
    rbaTierColourMapCache.set(picker, map);
    return map;
  };

  const updateRbaColourLabel = (picker, colourName) => {
    if (!colourName) return;
    const label = picker.querySelector('.rba-option--colours .rba-option__legend span');
    if (label) label.textContent = colourName;
  };

  const ensureValidColourForTier = (picker, tierName) => {
    const map = getRbaTierColourMap(picker);
    const validColours = map.get((tierName || '').toLowerCase());
    if (!validColours || !validColours.length) return null;

    const colourFieldset = picker.querySelector('.rba-option--colours');
    if (!colourFieldset) return null;

    const swatches = Array.from(colourFieldset.querySelectorAll('.rba-colour-swatch'));
    const checkedInput = colourFieldset.querySelector('input:checked');
    const checkedSwatch = checkedInput?.closest('.rba-colour-swatch');
    const checkedName = checkedSwatch?.getAttribute('title') || '';
    const isAvailable = (swatch) => swatch && !swatch.classList.contains('is-unavailable');

    if (checkedSwatch && validColours.includes(checkedName) && isAvailable(checkedSwatch)) {
      updateRbaColourLabel(picker, checkedName);
      return { input: checkedInput, swatch: checkedSwatch, mediaId: checkedSwatch.dataset.mediaId };
    }

    // Prefer the first colour valid for this tier that's actually available (not greyed out).
    let fallbackSwatch = null;
    for (const name of validColours) {
      const swatch = swatches.find((s) => s.getAttribute('title') === name);
      if (isAvailable(swatch)) { fallbackSwatch = swatch; break; }
    }
    // If every valid colour is marked unavailable, fall back to the first valid one anyway.
    if (!fallbackSwatch) {
      fallbackSwatch = swatches.find((s) => validColours.includes(s.getAttribute('title')));
    }
    if (!fallbackSwatch) return null;

    const fallbackInput = fallbackSwatch.querySelector('input');
    if (!fallbackInput) return null;

    if (checkedInput && checkedInput !== fallbackInput) checkedInput.checked = false;
    fallbackInput.checked = true;
    fallbackInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateRbaColourLabel(picker, fallbackSwatch.getAttribute('title'));
    return { input: fallbackInput, swatch: fallbackSwatch, mediaId: fallbackSwatch.dataset.mediaId };
  };

  const updateRbaGarmentProperty = (picker, shell) => {
    const garmentName = shell.dataset.rbaTierGarment;
    if (!garmentName) return;
    const form = picker.closest('.product-details')?.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    let input = form.querySelector('input[name="properties[_Garment]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_Garment]';
      form.appendChild(input);
    }
    input.value = garmentName;
  };

  const applyRbaInitialGarmentProperty = () => {
    document.querySelectorAll('.rba-tee-picker').forEach((picker) => {
      const shell = picker.querySelector('.rba-tier-list input:checked')?.closest('.rba-tier-shell');
      if (shell) updateRbaGarmentProperty(picker, shell);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaInitialGarmentProperty, { once: true });
  } else {
    requestAnimationFrame(applyRbaInitialGarmentProperty);
  }
  document.addEventListener('shopify:section:load', applyRbaInitialGarmentProperty);

  let rbaSuppressColourImageSwap = false;

  const handleRbaTierChange = (event) => {
    const input = event.target;
    if (!input.closest || !input.closest('.rba-tier-list')) return;

    const picker = input.closest('.rba-tee-picker');
    const shell = input.closest('.rba-tier-shell');
    if (!picker || !shell) return;

    clearRbaColourMediaLock(picker);
    clearRbaTierWatcher(picker);
    picker.dataset.rbaLastInteraction = 'tier';

    const tierName = shell.querySelector('.rba-tier-card__copy strong')?.textContent?.trim() || '';

    rbaSuppressColourImageSwap = true;
    ensureValidColourForTier(picker, tierName);
    rbaSuppressColourImageSwap = false;

    // Tier changes always reset the gallery to that tier's own mockup photo. A
    // colour-specific photo only takes over again once the customer manually clicks a
    // colour swatch (see handleRbaColourChange) — switching tiers clears that override.
    // Single Mockup Mode follows the same rule via lockRbaSingleMockupImage below: a
    // tier click always snaps back to the mockup, overriding any colour override.
    if (picker.dataset.rbaSingleMockupMode !== 'true') {
      const finalMediaId = shell.dataset.rbaTierMediaId || '';
      picker.dataset.rbaPendingMediaId = finalMediaId;

      if (finalMediaId) {
        selectGalleryMedia(picker, finalMediaId);
        watchRbaTierMedia(picker, finalMediaId);
      } else {
        clearRbaTierWatcher(picker);
      }
    } else {
      // Single Mockup Mode: a tier click always snaps the image back to the mockup
      // photo, overriding any colour-specific photo the customer had picked.
      lockRbaSingleMockupImage(picker);
    }
    updateRbaTopPrice(picker, shell);
    updateRbaGarmentProperty(picker, shell);
  };

  const handleRbaColourChange = (event) => {
    const input = event.target;
    if (!input.closest || !input.closest('.rba-option--colours')) return;
    const picker = input.closest('.rba-tee-picker');
    if (!picker) return;
    clearRbaTierWatcher(picker);
    const swatch = input.closest('.rba-colour-swatch');
    if (!rbaSuppressColourImageSwap) {
      picker.dataset.rbaLastInteraction = 'colour';

      // A colour click always shows that colour's own photo — even in Single Mockup
      // Mode. Stop the mockup watcher so it doesn't fight this; the next tier click
      // (see handleRbaTierChange) is what brings the mockup photo back.
      clearRbaSingleMockupWatcher(picker);

      const mediaId = swatch?.dataset.mediaId;
      if (mediaId) {
        picker.dataset.rbaPendingMediaId = mediaId;
        selectGalleryMedia(picker, mediaId);
        lockRbaColourMedia(picker, mediaId);
      }
    }
    updateRbaColourLabel(picker, swatch?.getAttribute('title'));
  };

  document.addEventListener('change', handleRbaTierChange, true);
  document.addEventListener('change', handleRbaColourChange, true);

  document.addEventListener('shopify:product:select', (event) => {
    const picker = event.target?.closest?.('.rba-tee-picker');
    if (!picker) return;

    const pendingMediaId = picker.dataset.rbaPendingMediaId;
    if (pendingMediaId && picker.dataset.rbaLastInteraction === 'colour') {
      lockRbaColourMedia(picker, pendingMediaId);
    }

    Promise.resolve(event.promise)
      .then(() => {
        const tierInput = picker.querySelector('.rba-tier-list input:checked');
        const tierName = tierInput
          ?.closest('.rba-tier-shell')
          ?.querySelector('.rba-tier-card__copy strong')
          ?.textContent
          ?.trim() || '';
        if (picker.dataset.rbaLastInteraction !== 'colour' && tierName) {
          ensureValidColourForTier(picker, tierName);
        }

        // Re-assert whatever image we decided on, AFTER Shopify's own swap has landed.
        // This is what actually stops the flash — no more racing against a timer.
        // Runs in every mode now, including Single Mockup Mode, since a colour click
        // in that mode also needs this re-assertion to hold up against Shopify's fetch.
        const finalPendingId = picker.dataset.rbaPendingMediaId;
        if (finalPendingId) {
          requestAnimationFrame(() => selectGalleryMedia(picker, finalPendingId));
        }

        if (picker.dataset.rbaSingleMockupMode === 'true') {
          if (picker.dataset.rbaTierChosen === 'true') {
            picker.querySelector('.rba-option--tiers')?.classList.add('rba-user-selected');
          }
          if (picker.dataset.rbaColourChosen === 'true') {
            picker.querySelector('.rba-option--colours')?.classList.add('rba-user-selected');
          }
          if (picker.dataset.rbaSizeChosen === 'true') {
            picker.querySelector('.rba-option--sizes')?.classList.add('rba-user-selected');
          }
        }
      })
      .catch(() => {});
  });

  const clearRbaSingleMockupWatcher = (picker) => {
    const watcher = picker._rbaSingleMockupWatcher;
    if (!watcher) return;
    window.clearInterval(watcher.interval);
    watcher.observer.disconnect();
    picker._rbaSingleMockupWatcher = null;
  };

  // Same MutationObserver + fast-interval approach as watchRbaTierMedia, but this one
  // runs for the picker's whole lifetime (no duration cutoff) since Single Mockup Mode's
  // entire point is "always show this one photo," not just during a transition.
  // Puts the picker back into "always show the mockup" state: selects the mockup
  // photo right now, and restarts the persistent watcher that keeps re-asserting it.
  // Used on page load AND every time a tier is clicked (see handleRbaTierChange).
  const lockRbaSingleMockupImage = (picker) => {
    const mediaId = picker.dataset.rbaSingleMockupId;
    if (!mediaId) return;
    picker.dataset.rbaPendingMediaId = mediaId;
    selectGalleryMedia(picker, mediaId);
    watchRbaSingleMockup(picker, mediaId);
  };

  const watchRbaSingleMockup = (picker, mediaId) => {
    clearRbaSingleMockupWatcher(picker);
    if (!mediaId) return;

    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    if (!gallery) return;

    const reassert = () => selectGalleryMedia(picker, mediaId);
    const observer = new MutationObserver(reassert);
    observer.observe(gallery, { childList: true, subtree: true, attributes: true });
    const interval = window.setInterval(reassert, 50);

    picker._rbaSingleMockupWatcher = { interval, observer };
    reassert();
  };

  const applyRbaSingleMockup = () => {
    document.querySelectorAll('.rba-tee-picker[data-rba-single-mockup-mode="true"]').forEach((picker) => {
      if (picker.dataset.rbaSingleMockupApplied === 'true') return;
      picker.dataset.rbaSingleMockupApplied = 'true';

      lockRbaSingleMockupImage(picker);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaSingleMockup, { once: true });
  } else {
    requestAnimationFrame(applyRbaSingleMockup);
  }


  // The picker markup is replaced on every variant change, so the chosen state cannot live on
  // the picker element - it was wiped a frame after the click and the selected pill snapped
  // straight back to the unselected background. <html> survives the re-render.
  const rbaChoiceRoot = document.documentElement;

  const rbaResetChoicesIfProductChanged = (picker) => {
    const handle = picker.dataset.productHandle || '';
    if (rbaChoiceRoot.dataset.rbaChoiceHandle === handle) return;

    rbaChoiceRoot.dataset.rbaChoiceHandle = handle;
    delete rbaChoiceRoot.dataset.rbaTierChosen;
    delete rbaChoiceRoot.dataset.rbaColourChosen;
    delete rbaChoiceRoot.dataset.rbaSizeChosen;
    delete rbaChoiceRoot.dataset.rbaAllChosen;
  };

  const markRbaChosen = (picker, kind) => {
    rbaResetChoicesIfProductChanged(picker);
    rbaChoiceRoot.dataset['rba' + kind + 'Chosen'] = 'true';
    if (
      rbaChoiceRoot.dataset.rbaTierChosen === 'true' &&
      rbaChoiceRoot.dataset.rbaColourChosen === 'true' &&
      rbaChoiceRoot.dataset.rbaSizeChosen === 'true'
    ) {
      rbaChoiceRoot.dataset.rbaAllChosen = 'true';
    }
  };

  document.addEventListener('click', (event) => {
    const tierCard = event.target.closest?.('.rba-tier-card');
    if (tierCard) {
      const picker = tierCard.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        tierCard.closest('.rba-option--tiers')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Tier');
      }
      return;
    }

    const colourSwatch = event.target.closest?.('.rba-colour-swatch');
    if (colourSwatch) {
      const picker = colourSwatch.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        colourSwatch.closest('.rba-option--colours')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Colour');
      }
      return;
    }

    const sizeButton = event.target.closest?.('.rba-size-button');
    if (sizeButton) {
      const picker = sizeButton.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        sizeButton.closest('.rba-option--sizes')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Size');
      }
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const picker = form.closest('.product-details')?.querySelector('.rba-tee-picker[data-rba-single-mockup-mode="true"]');
    if (!picker) return;
    if (document.documentElement.dataset.rbaAllChosen !== 'true') {
      event.preventDefault();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rba-custom-apparel-variant-picker"] && !Shopify.designMode) return;
  try {
    const rbaApparelNormalize = (value) => {
  return String(value || '').trim().toLowerCase();
};

const rbaApparelBuildColourMap = (raw) => {
  const map = {};

  String(raw || '')
    .split(/\r?\n/)
    .forEach((line) => {
      const separator = line.indexOf('|');

      if (separator === -1) return;

      const name = line.substring(0, separator).trim();
      const colour = line.substring(separator + 1).trim();

      if (!name || !colour) return;

      map[rbaApparelNormalize(name)] = colour;
    });

  return map;
};

const rbaApparelApplyColourMap = (picker) => {
  if (!picker) return;

  const mapElement = picker.querySelector('[data-rba-colour-map]');
  if (!mapElement) return;

  let rawMap = '';

  try {
    rawMap = JSON.parse(mapElement.textContent) || '';
  } catch (error) {
    rawMap = '';
  }

  const colourMap = rbaApparelBuildColourMap(rawMap);

  picker
    .querySelectorAll('[data-rba-colour-circle]')
    .forEach((circle) => {
      const colourName = circle.dataset.rbaColourCircle;
      const mappedColour = colourMap[rbaApparelNormalize(colourName)];

      circle.style.backgroundColor = mappedColour || '#d7d7d7';
    });
};

const rbaApparelSyncPicker = (picker) => {
  if (!picker) return;

  const colourFieldset = picker.querySelector('.rba-apparel-option--colours');

  if (colourFieldset) {
    const checkedColour = colourFieldset.querySelector('input:checked');
    const checkedColourWrapper = checkedColour?.closest('[data-rba-colour-name]');
    const colourName = checkedColourWrapper?.dataset.rbaColourName || '';

    const dropdown = colourFieldset.querySelector('[data-rba-colour-select]');
    const colourText = colourFieldset.querySelector('[data-rba-colour-label]');

    if (dropdown && colourName) dropdown.value = colourName;
    if (colourText && colourName) colourText.textContent = colourName;
  }

  const sizeFieldset = picker.querySelector('.rba-apparel-option--sizes');

  if (sizeFieldset) {
    const checkedSize = sizeFieldset.querySelector('input:checked');
    const checkedSizeWrapper = checkedSize?.closest('[data-rba-size-name]');
    const sizeName = checkedSizeWrapper?.dataset.rbaSizeName || '';
    const sizeText = sizeFieldset.querySelector('[data-rba-size-label]');

    if (sizeText && sizeName) sizeText.textContent = sizeName;
  }
};

const rbaApparelInitialize = (root = document) => {
  root
    .querySelectorAll('.rba-apparel-picker')
    .forEach((picker) => {
      rbaApparelApplyColourMap(picker);
      rbaApparelSyncPicker(picker);
    });
};

document.addEventListener(
  'change',
  (event) => {
    const dropdown = event.target.closest?.('[data-rba-colour-select]');

    if (dropdown) {
      const picker = dropdown.closest('.rba-apparel-picker');
      if (!picker) return;

      const desiredColour = dropdown.value;

      const labels = Array.from(
        picker.querySelectorAll('[data-rba-colour-name]')
      );

      const matchingLabel = labels.find(
        (label) =>
          rbaApparelNormalize(label.dataset.rbaColourName) ===
          rbaApparelNormalize(desiredColour)
      );

      const input = matchingLabel?.querySelector('input');

      if (!input) return;

      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      const colourLabel = picker.querySelector('[data-rba-colour-label]');

      if (colourLabel) {
        colourLabel.textContent = desiredColour;
      }

      return;
    }

    const picker = event.target.closest?.('.rba-apparel-picker');

    if (!picker) return;

    requestAnimationFrame(() => {
      rbaApparelSyncPicker(picker);
      rbaApparelApplyColourMap(picker);
    });
  },
  true
);

document.addEventListener(
  'shopify:product:select',
  (event) => {
    const picker = event.target?.closest?.('.rba-apparel-picker');

    if (!picker) return;

    Promise.resolve(event.promise)
      .then(() => {
        requestAnimationFrame(() => {
          const currentPicker =
            document.querySelector(
              `.rba-apparel-picker[data-block-id="${picker.dataset.blockId}"]`
            ) || picker;

          rbaApparelApplyColourMap(currentPicker);
          rbaApparelSyncPicker(currentPicker);
        });
      })
      .catch(() => {});
  }
);

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      rbaApparelInitialize();
    },
    { once: true }
  );
} else {
  requestAnimationFrame(() => {
    rbaApparelInitialize();
  });
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    rbaApparelInitialize(event.target);
  }
);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rba-selection-summary"] && !Shopify.designMode) return;
  try {
    const formatRbaMoney = (money) => {
    if (!money?.amount || !money?.currencyCode) return '';

    const amount = Number(money.amount);
    if (!Number.isFinite(amount)) return '';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || navigator.language || 'en-CA', {
        style: 'currency',
        currency: money.currencyCode,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (_error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const modelForRbaTier = (summary, teeStyle) => {
    const key = (teeStyle || '').toLowerCase();
    if (key.includes('essential')) return summary.dataset.essentialModel || '';
    if (key.includes('premium')) return summary.dataset.premiumModel || '';
    if (key.includes('elevated')) return summary.dataset.elevatedModel || '';
    return '';
  };

  const updateRbaSelectionCopy = (summary, selectedOptions) => {
    const options = Array.isArray(selectedOptions) ? selectedOptions : [];
    let teeStyle = '';
    let colour = '';
    let size = '';

    options.forEach((option) => {
      const key = (option?.name || '').toLowerCase();
      if (key.includes('tee style') || key === 'style') teeStyle = option.value || '';
      else if (key.includes('colour') || key.includes('color')) colour = option.value || '';
      else if (key.includes('size')) size = option.value || '';
    });

    // RBA 2026-09-24: lookup-table products have no Colour option; the chosen colour lives on <html>.
    const lookup = document.documentElement.dataset;
    if (!colour && lookup.rbaChosenHandle === summary.dataset.productHandle) colour = lookup.rbaChosenColour || '';

    const model = modelForRbaTier(summary, teeStyle);
    const pieces = [];
    if (teeStyle) pieces.push(`${teeStyle}${model ? ` (${model})` : ''}`);
    if (colour) pieces.push(colour);
    if (size) pieces.push(size);

    const copy = summary.querySelector('[data-rba-selection-text]');
    if (!copy || !pieces.length) return;

    // Rebuild the per-option spans rather than flattening to one string, so single mockup mode
    // can keep hiding the options the customer has not chosen yet.
    const parts = [
      ['tier', teeStyle ? `${teeStyle}${model ? ` (${model})` : ''}` : '', 'Choose a style'],
      ['colour', colour, ' · choose a colour'],
      ['size', size, ' · choose a size'],
    ];

    const nodes = [];
    parts.forEach(([key, value, prompt], index) => {
      if (value) {
        const valueSpan = document.createElement('span');
        valueSpan.dataset.rbaPart = key;
        valueSpan.textContent = index === 0 ? value : ` · ${value}`;
        nodes.push(valueSpan);
      }

      const promptSpan = document.createElement('span');
      promptSpan.dataset.rbaPrompt = key;
      promptSpan.textContent = prompt;
      nodes.push(promptSpan);
    });

    copy.replaceChildren(...nodes);
  };

  const rbaTierPriceCache = new Map();
  const rbaLastTierPrice = new Map();
  const rbaTierPriceRequests = new Map();

  const rbaTierPriceNode = (tierInput) => {
    const copy = tierInput?.closest('.rba-tier-card')?.querySelector('.rba-tier-card__copy');
    if (!copy) return null;

    let price = copy.querySelector('b');
    if (!price) {
      price = document.createElement('b');
      price.setAttribute('data-rba-tier-price', '');
      copy.append(price);
    }
    return price;
  };

  const rbaTierPriceKeys = (picker, tierInput, sizeInput) => {
    const productId = picker?.dataset.productId || '';
    const tierId = tierInput?.dataset.optionValueId || '';
    const sizeId = sizeInput?.dataset.optionValueId || '';
    return {
      exact: `${productId}:${tierId}:${sizeId}`,
      tier: `${productId}:${tierId}`,
    };
  };

  const captureRbaTierPrices = (picker) => {
    const sizeInput = picker?.querySelector('.rba-option--sizes input:checked[data-option-value-id]');
    if (!picker || !sizeInput) return;

    picker.querySelectorAll('.rba-option--tiers input[data-option-value-id]').forEach((tierInput) => {
      const price = tierInput.closest('.rba-tier-card')?.querySelector('.rba-tier-card__copy b');
      const text = price?.textContent?.trim();
      if (!text) return;

      const keys = rbaTierPriceKeys(picker, tierInput, sizeInput);
      rbaTierPriceCache.set(keys.exact, text);
      rbaLastTierPrice.set(keys.tier, text);
    });
  };

  const fetchRbaTierPrice = (picker, tierInput, sizeInput) => {
    const keys = rbaTierPriceKeys(picker, tierInput, sizeInput);
    if (rbaTierPriceRequests.has(keys.exact)) return rbaTierPriceRequests.get(keys.exact);

    const request = (async () => {
      try {
        const tierId = tierInput.dataset.optionValueId;
        const sizeId = sizeInput.dataset.optionValueId;
        if (!tierId || !sizeId || !picker.dataset.sectionId) return '';

        const productUrl = new URL(picker.dataset.productUrl || window.location.pathname, window.location.origin);
        const currentUrl = new URL(window.location.href);
        const url = new URL(productUrl.pathname, window.location.origin);

        currentUrl.searchParams.forEach((value, key) => {
          if (key.startsWith('preview_') || key === 'pb') url.searchParams.set(key, value);
        });

        url.searchParams.set('section_id', picker.dataset.sectionId);
        url.searchParams.set('option_values', `${tierId},${sizeId}`);

        const response = await fetch(url.toString(), {
          headers: { Accept: 'text/html' },
        });
        if (!response.ok) return '';

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedTier = doc.querySelector(
          `.rba-option--tiers input[data-option-value-id="${CSS.escape(tierId)}"]`
        );
        return fetchedTier
          ?.closest('.rba-tier-card')
          ?.querySelector('.rba-tier-card__copy b')
          ?.textContent
          ?.trim() || '';
      } catch (_error) {
        return '';
      } finally {
        rbaTierPriceRequests.delete(keys.exact);
      }
    })();

    rbaTierPriceRequests.set(keys.exact, request);
    return request;
  };

  const hydrateRbaTierPrices = async (picker) => {
    const sizeInput = picker?.querySelector('.rba-option--sizes input:checked[data-option-value-id]');
    const tierInputs = Array.from(
      picker?.querySelectorAll('.rba-option--tiers input[data-option-value-id]') || []
    );
    if (!picker || !sizeInput || !tierInputs.length) return;

    await Promise.all(
      tierInputs.map(async (tierInput) => {
        const keys = rbaTierPriceKeys(picker, tierInput, sizeInput);
        const priceNode = rbaTierPriceNode(tierInput);
        if (!priceNode) return;

        const renderedPrice = priceNode.textContent?.trim();
        if (renderedPrice) {
          rbaTierPriceCache.set(keys.exact, renderedPrice);
          rbaLastTierPrice.set(keys.tier, renderedPrice);
          return;
        }

        const cachedPrice = rbaTierPriceCache.get(keys.exact);
        if (cachedPrice) {
          priceNode.textContent = cachedPrice;
          return;
        }

        const lastTierPrice = rbaLastTierPrice.get(keys.tier);
        if (lastTierPrice) priceNode.textContent = lastTierPrice;

        const fetchedPrice = await fetchRbaTierPrice(picker, tierInput, sizeInput);
        if (!fetchedPrice) return;

        priceNode.textContent = fetchedPrice;
        rbaTierPriceCache.set(keys.exact, fetchedPrice);
        rbaLastTierPrice.set(keys.tier, fetchedPrice);
      })
    );
  };

  const initializeRbaTierPrices = (root = document) => {
    root.querySelectorAll?.('.rba-tee-picker').forEach((picker) => {
      captureRbaTierPrices(picker);
      hydrateRbaTierPrices(picker);
    });
  };

  document.addEventListener('shopify:product:select', (event) => {
    const section = event.target?.closest?.('.shopify-section');
    const oldPicker = event.target?.closest?.('.rba-tee-picker') || section?.querySelector?.('.rba-tee-picker');
    let summary = section?.querySelector?.('.rba-selection-summary');

    captureRbaTierPrices(oldPicker);

    if (!summary && event.product?.handle) {
      summary = document.querySelector(`.rba-selection-summary[data-product-handle="${CSS.escape(event.product.handle)}"]`);
    }

    if (!summary) return;

    updateRbaSelectionCopy(summary, event.selectedOptions);

    Promise.resolve(event.promise)
      .then(({ variant } = {}) => {
        const currentSummary = section?.querySelector?.('.rba-selection-summary') || summary;
        const price = currentSummary?.querySelector?.('[data-rba-selection-price]');

        if (price) {
          if (!variant) {
            price.textContent = 'Unavailable';
          } else {
            const formattedPrice = formatRbaMoney(variant.price);
            if (formattedPrice) price.textContent = formattedPrice;
          }
        }

        const currentPicker = section?.querySelector?.('.rba-tee-picker');
        hydrateRbaTierPrices(currentPicker);
      })
      .catch(() => {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeRbaTierPrices(), { once: true });
  } else {
    requestAnimationFrame(() => initializeRbaTierPrices());
  }

  document.addEventListener('shopify:section:load', (event) => initializeRbaTierPrices(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rba-tee-variant-picker"] && !Shopify.designMode) return;
  try {
    const showRbaFeaturedMedia = () => {
    document.querySelectorAll('.rba-tee-picker').forEach((picker) => {
      if (picker.dataset.rbaInitialMediaReady === 'true') return;

      // Prefer the currently-checked tier's own mockup photo on first load. Mockups should
      // always be visible by default; the plain/product-default photo only ever shows if
      // this particular tier has no mockup photo tagged for it at all.
      const checkedShell = picker.querySelector('.rba-tier-list input:checked')?.closest('.rba-tier-shell');
      const mediaId = checkedShell?.dataset.rbaTierMediaId || picker.dataset.rbaFeaturedMediaId;

      const section = picker.closest('.shopify-section');
      const gallery = section?.querySelector('media-gallery');
      const slideshow = gallery?.slideshow;
      const slides = slideshow?.slides;

      if (!mediaId || !slideshow || !slides?.length) return;

      const targetIndex = slides.findIndex((slide) => slide.querySelector(`.product-media[data-media-id="${mediaId}"]`));
      if (targetIndex < 0) return;

      slideshow.select(targetIndex, undefined, { animate: false });
      picker.dataset.rbaPendingMediaId = mediaId;
      picker.dataset.rbaInitialMediaReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showRbaFeaturedMedia, { once: true });
  } else {
    requestAnimationFrame(showRbaFeaturedMedia);
  }


  const applyRbaDefaultTier = () => {
    document.querySelectorAll('.rba-tee-picker[data-rba-default-tier]').forEach((picker) => {
      if (picker.dataset.rbaDefaultTierApplied === 'true') return;
      picker.dataset.rbaDefaultTierApplied = 'true';

      const defaultTier = picker.dataset.rbaDefaultTier;
      if (!defaultTier) return;

      try {
        const url = new URL(window.location.href);
        if (url.searchParams.has('variant')) return;
      } catch (error) {}

      const shells = Array.from(picker.querySelectorAll('.rba-tier-list .rba-tier-shell'));
      const targetShell = shells.find((shell) => {
        const name = shell.querySelector('.rba-tier-card__copy strong')?.textContent?.trim().toLowerCase() || '';
        return name === defaultTier;
      });
      if (!targetShell) return;

      const input = targetShell.querySelector('input');
      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaDefaultTier, { once: true });
  } else {
    requestAnimationFrame(applyRbaDefaultTier);
  }

  const selectGalleryMedia = (picker, mediaId) => {
    if (!mediaId) return false;
    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    const slideshow = gallery?.slideshow;
    const slides = slideshow?.slides;
    if (!slideshow || !slides?.length) return false;

    const targetIndex = slides.findIndex((slide) => slide.querySelector(`.product-media[data-media-id="${mediaId}"]`));
    if (targetIndex < 0) return false;

    const currentIndex = typeof slideshow.selected === 'number' ? slideshow.selected : slideshow.current;
    if (currentIndex !== targetIndex) {
      slideshow.select(targetIndex, undefined, { animate: false });
    }
    return true;
  };

  const clearRbaTierWatcher = (picker) => {
    const watcher = picker._rbaTierWatcher;
    if (!watcher) return;
    window.clearInterval(watcher.interval);
    watcher.observer?.disconnect();
    picker._rbaTierWatcher = null;
  };

  // Watches the gallery via MutationObserver instead of guessing with fixed timeouts.
  // This is what actually stops the single-frame flash: a same-tick DOM override (from
  // Shopify's own native variant-select behaviour, which we don't control and which can
  // run faster than a requestAnimationFrame/setTimeout retry) gets corrected the instant
  // it happens, not on a schedule that might be a frame too slow.
  const watchRbaTierMedia = (picker, mediaId, duration = 1500) => {
    clearRbaTierWatcher(picker);
    if (!mediaId) return;

    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    if (!gallery) return;

    const stopAt = performance.now() + duration;

    const reassert = () => {
      if (picker.dataset.rbaLastInteraction !== 'tier') { clearRbaTierWatcher(picker); return; }
      if (performance.now() >= stopAt) { clearRbaTierWatcher(picker); return; }
      selectGalleryMedia(picker, mediaId);
    };

    const observer = new MutationObserver(reassert);
    observer.observe(gallery, { childList: true, subtree: true, attributes: true });
    const interval = window.setInterval(reassert, 50);

    picker._rbaTierWatcher = { interval, observer };
    reassert();
  };

  const clearRbaColourMediaLock = (picker) => {
    const lock = picker._rbaColourMediaLock;
    if (!lock) return;
    window.cancelAnimationFrame(lock.raf);
    picker._rbaColourMediaLock = null;
  };

  const lockRbaColourMedia = (picker, mediaId, duration = 2200) => {
    clearRbaColourMediaLock(picker);
    if (!mediaId) return;

    const stopAt = performance.now() + duration;
    const lock = { mediaId, raf: 0 };
    picker._rbaColourMediaLock = lock;

    const tick = () => {
      if (picker._rbaColourMediaLock !== lock) return;
      if (picker.dataset.rbaLastInteraction !== 'colour' || performance.now() >= stopAt) {
        clearRbaColourMediaLock(picker);
        return;
      }

      selectGalleryMedia(picker, mediaId);
      lock.raf = window.requestAnimationFrame(tick);
    };

    lock.raf = window.requestAnimationFrame(tick);
  };

  const updateRbaTopPrice = (picker, shell) => {
    const priceText = shell.querySelector('.rba-tier-card__copy b')?.textContent?.trim();
    if (!priceText) return;
    const section = picker.closest('.shopify-section');
    const moneyEl = section?.querySelector('[ref="priceContainer"] .price .money');
    if (moneyEl) moneyEl.textContent = priceText;

    const summaryPriceEl = section?.querySelector('[data-rba-selection-price]');
    if (summaryPriceEl) summaryPriceEl.textContent = priceText;
  };

  const rbaTierColourMapCache = new WeakMap();

  const getRbaTierColourMap = (picker) => {
    if (rbaTierColourMapCache.has(picker)) return rbaTierColourMapCache.get(picker);
    const raw = picker.dataset.rbaTierColourPairs || '';
    const map = new Map();
    raw.split(';;').forEach((pair) => {
      if (!pair) return;
      const [tier, colour] = pair.split('||');
      if (!tier || !colour) return;
      const key = tier.toLowerCase();
      if (!map.has(key)) map.set(key, []);
      const list = map.get(key);
      if (!list.includes(colour)) list.push(colour);
    });
    rbaTierColourMapCache.set(picker, map);
    return map;
  };

  const updateRbaColourLabel = (picker, colourName) => {
    if (!colourName) return;
    const label = picker.querySelector('.rba-option--colours .rba-option__legend span');
    if (label) label.textContent = colourName;
  };

  const ensureValidColourForTier = (picker, tierName) => {
    const map = getRbaTierColourMap(picker);
    const validColours = map.get((tierName || '').toLowerCase());
    if (!validColours || !validColours.length) return null;

    const colourFieldset = picker.querySelector('.rba-option--colours');
    if (!colourFieldset) return null;

    const swatches = Array.from(colourFieldset.querySelectorAll('.rba-colour-swatch'));
    const checkedInput = colourFieldset.querySelector('input:checked');
    const checkedSwatch = checkedInput?.closest('.rba-colour-swatch');
    const checkedName = checkedSwatch?.getAttribute('title') || '';
    const isAvailable = (swatch) => swatch && !swatch.classList.contains('is-unavailable');

    if (checkedSwatch && validColours.includes(checkedName) && isAvailable(checkedSwatch)) {
      updateRbaColourLabel(picker, checkedName);
      return { input: checkedInput, swatch: checkedSwatch, mediaId: checkedSwatch.dataset.mediaId };
    }

    // Prefer the first colour valid for this tier that's actually available (not greyed out).
    let fallbackSwatch = null;
    for (const name of validColours) {
      const swatch = swatches.find((s) => s.getAttribute('title') === name);
      if (isAvailable(swatch)) { fallbackSwatch = swatch; break; }
    }
    // If every valid colour is marked unavailable, fall back to the first valid one anyway.
    if (!fallbackSwatch) {
      fallbackSwatch = swatches.find((s) => validColours.includes(s.getAttribute('title')));
    }
    if (!fallbackSwatch) return null;

    const fallbackInput = fallbackSwatch.querySelector('input');
    if (!fallbackInput) return null;

    if (checkedInput && checkedInput !== fallbackInput) checkedInput.checked = false;
    fallbackInput.checked = true;
    fallbackInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateRbaColourLabel(picker, fallbackSwatch.getAttribute('title'));
    return { input: fallbackInput, swatch: fallbackSwatch, mediaId: fallbackSwatch.dataset.mediaId };
  };

  const updateRbaGarmentProperty = (picker, shell) => {
    const garmentName = shell.dataset.rbaTierGarment;
    if (!garmentName) return;
    const form = picker.closest('.product-details')?.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    let input = form.querySelector('input[name="properties[_Garment]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_Garment]';
      form.appendChild(input);
    }
    input.value = garmentName;
  };

  const applyRbaInitialGarmentProperty = () => {
    document.querySelectorAll('.rba-tee-picker').forEach((picker) => {
      const shell = picker.querySelector('.rba-tier-list input:checked')?.closest('.rba-tier-shell');
      if (shell) updateRbaGarmentProperty(picker, shell);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaInitialGarmentProperty, { once: true });
  } else {
    requestAnimationFrame(applyRbaInitialGarmentProperty);
  }
  document.addEventListener('shopify:section:load', applyRbaInitialGarmentProperty);

  let rbaSuppressColourImageSwap = false;

  const handleRbaTierChange = (event) => {
    const input = event.target;
    if (!input.closest || !input.closest('.rba-tier-list')) return;

    const picker = input.closest('.rba-tee-picker');
    const shell = input.closest('.rba-tier-shell');
    if (!picker || !shell) return;

    clearRbaColourMediaLock(picker);
    clearRbaTierWatcher(picker);
    picker.dataset.rbaLastInteraction = 'tier';

    const tierName = shell.querySelector('.rba-tier-card__copy strong')?.textContent?.trim() || '';

    rbaSuppressColourImageSwap = true;
    ensureValidColourForTier(picker, tierName);
    rbaSuppressColourImageSwap = false;

    // Tier changes always reset the gallery to that tier's own mockup photo. A
    // colour-specific photo only takes over again once the customer manually clicks a
    // colour swatch (see handleRbaColourChange) — switching tiers clears that override.
    const finalMediaId = shell.dataset.rbaTierMediaId || '';
    picker.dataset.rbaPendingMediaId = finalMediaId;

    if (finalMediaId) {
      selectGalleryMedia(picker, finalMediaId);
      watchRbaTierMedia(picker, finalMediaId);
    } else {
      clearRbaTierWatcher(picker);
    }
    updateRbaTopPrice(picker, shell);
    updateRbaGarmentProperty(picker, shell);
  };

  const handleRbaColourChange = (event) => {
    const input = event.target;
    if (!input.closest || !input.closest('.rba-option--colours')) return;
    const picker = input.closest('.rba-tee-picker');
    if (!picker) return;
    clearRbaTierWatcher(picker);
    const swatch = input.closest('.rba-colour-swatch');
    if (!rbaSuppressColourImageSwap) {
      picker.dataset.rbaLastInteraction = 'colour';

      const singleWatcher = picker._rbaSingleMockupWatcher;
      if (singleWatcher) {
        window.clearInterval(singleWatcher.interval);
        singleWatcher.observer.disconnect();
        picker._rbaSingleMockupWatcher = null;
      }

      const mediaId = swatch?.dataset.mediaId;
      if (mediaId) {
        picker.dataset.rbaPendingMediaId = mediaId;
        selectGalleryMedia(picker, mediaId);
        lockRbaColourMedia(picker, mediaId);
      }
    }
    updateRbaColourLabel(picker, swatch?.getAttribute('title'));
  };

  document.addEventListener('change', handleRbaTierChange, true);
  document.addEventListener('change', handleRbaColourChange, true);

  document.addEventListener('shopify:product:select', (event) => {
    const picker = event.target?.closest?.('.rba-tee-picker');
    if (!picker) return;

    const pendingMediaId = picker.dataset.rbaPendingMediaId;
    if (pendingMediaId && picker.dataset.rbaLastInteraction === 'colour') {
      lockRbaColourMedia(picker, pendingMediaId);
    }

    Promise.resolve(event.promise)
      .then(() => {
        const tierInput = picker.querySelector('.rba-tier-list input:checked');
        const tierName = tierInput
          ?.closest('.rba-tier-shell')
          ?.querySelector('.rba-tier-card__copy strong')
          ?.textContent
          ?.trim() || '';
        if (picker.dataset.rbaLastInteraction !== 'colour' && tierName) {
          ensureValidColourForTier(picker, tierName);
        }

        // Re-assert whatever image we decided on, AFTER Shopify's own swap has landed.
        // This is what actually stops the flash — no more racing against a timer.
        const finalPendingId = picker.dataset.rbaPendingMediaId;
        if (finalPendingId) {
          requestAnimationFrame(() => selectGalleryMedia(picker, finalPendingId));
        }
      })
      .catch(() => {});
  });

  const clearRbaSingleMockupWatcher = (picker) => {
    const watcher = picker._rbaSingleMockupWatcher;
    if (!watcher) return;
    window.clearInterval(watcher.interval);
    watcher.observer.disconnect();
    picker._rbaSingleMockupWatcher = null;
  };

  const watchRbaSingleMockup = (picker, mediaId) => {
    clearRbaSingleMockupWatcher(picker);
    if (!mediaId) return;

    const section = picker.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    if (!gallery) return;

    const reassert = () => selectGalleryMedia(picker, mediaId);
    const observer = new MutationObserver(reassert);
    observer.observe(gallery, { childList: true, subtree: true, attributes: true });
    const interval = window.setInterval(reassert, 250);

    picker._rbaSingleMockupWatcher = { interval, observer };
  };

  const applyRbaSingleMockup = () => {
    document.querySelectorAll('.rba-tee-picker[data-rba-single-mockup-mode="true"]').forEach((picker) => {
      if (picker.dataset.rbaSingleMockupApplied === 'true') return;
      picker.dataset.rbaSingleMockupApplied = 'true';

      const mediaId = picker.dataset.rbaSingleMockupId;
      if (!mediaId) return;

      selectGalleryMedia(picker, mediaId);
      watchRbaSingleMockup(picker, mediaId);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRbaSingleMockup, { once: true });
  } else {
    requestAnimationFrame(applyRbaSingleMockup);
  }


  // The picker markup is replaced on every variant change, so the chosen state cannot live on
  // the picker element - it was wiped a frame after the click and the selected pill snapped
  // straight back to the unselected background. <html> survives the re-render.
  const rbaChoiceRoot = document.documentElement;

  const rbaResetChoicesIfProductChanged = (picker) => {
    const handle = picker.dataset.productHandle || '';
    if (rbaChoiceRoot.dataset.rbaChoiceHandle === handle) return;

    rbaChoiceRoot.dataset.rbaChoiceHandle = handle;
    delete rbaChoiceRoot.dataset.rbaTierChosen;
    delete rbaChoiceRoot.dataset.rbaColourChosen;
    delete rbaChoiceRoot.dataset.rbaSizeChosen;
    delete rbaChoiceRoot.dataset.rbaAllChosen;
  };

  const markRbaChosen = (picker, kind) => {
    rbaResetChoicesIfProductChanged(picker);
    rbaChoiceRoot.dataset['rba' + kind + 'Chosen'] = 'true';
    if (
      rbaChoiceRoot.dataset.rbaTierChosen === 'true' &&
      rbaChoiceRoot.dataset.rbaColourChosen === 'true' &&
      rbaChoiceRoot.dataset.rbaSizeChosen === 'true'
    ) {
      rbaChoiceRoot.dataset.rbaAllChosen = 'true';
    }
  };

  document.addEventListener('click', (event) => {
    const tierCard = event.target.closest?.('.rba-tier-card');
    if (tierCard) {
      const picker = tierCard.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        tierCard.closest('.rba-option--tiers')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Tier');
      }
      return;
    }

    const colourSwatch = event.target.closest?.('.rba-colour-swatch');
    if (colourSwatch) {
      const picker = colourSwatch.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        colourSwatch.closest('.rba-option--colours')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Colour');
        clearRbaSingleMockupWatcher(picker);
      }
      return;
    }

    const sizeButton = event.target.closest?.('.rba-size-button');
    if (sizeButton) {
      const picker = sizeButton.closest('.rba-tee-picker');
      if (picker && picker.dataset.rbaSingleMockupMode === 'true') {
        sizeButton.closest('.rba-option--sizes')?.classList.add('rba-user-selected');
        markRbaChosen(picker, 'Size');
      }
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const picker = form.closest('.product-details')?.querySelector('.rba-tee-picker[data-rba-single-mockup-mode="true"]');
    if (!picker) return;
    if (document.documentElement.dataset.rbaAllChosen !== 'true') {
      event.preventDefault();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
